export const STORAGE_KEYS = {
  TOKEN: 'token',
  TELEGRAM_USER_ID: 'telegramUserId',
  USER: 'user',
  LOCALE: 'locale',
  PREFERRED_LANGUAGE: 'preferredLanguage',
  THEME_MODE: 'themeMode',
  THEME_MODE: 'themeMode',
  REMEMBER_EMAIL: 'remember_email',
  ADDRESS_LIST: 'addressList',
  SELECTED_ADDRESS: 'selectedAddress',
  CLIENT_ID: 'client_id',
  UTM_PARAMS: 'utm_params',
  APP_SOURCE: 'app_source',
  PRODUCT_LIST: 'productList',
  SIM_PRODUCT_LIST: 'simProductList',
  HOME_ACTIVE_TAB: 'homeActiveTab',
}
